// ProjectShowcase.js
import React from "react";
import "./project.css"; // Import CSS file
import Icons from "../../../../config/images";

const ProjectShowcase = () => {
  return (
    <div className="project-showcase">
      <div className="project-header">
      <div className="heading-container">
        <span className="green-line"></span>
        <span className="project-gray-text-style">Our Projects</span>
      </div>
        <h2>Showcasing Innovation, Building Connections</h2>
      </div>
      <div className="project-logo-container">
        <img src={Icons.zabali} alt="ZABALI Logo" className="project-logo" />
      </div>
    </div>
  );
};

export default ProjectShowcase;
